import { runBuildCli } from "./build.impl";

await runBuildCli();
